import { buildQueryVariables } from '../../helpers';

/**
 * @param {{
 *   SimpleOrderService: ReturnType<import('../../services/SimpleOrderService').default>,
 * }} param0
 */
export default function simpleOrderUseCase({ SimpleOrderService }) {
  const createSimpleOrder = (input) => {
    // Clean up optional fields
    const cleanedInput = { ...input };

    if (
      Array.isArray(cleanedInput.productDetailIds) &&
      cleanedInput.productDetailIds.length === 0
    ) {
      delete cleanedInput.productDetailIds;
    }

    if (!cleanedInput.description) {
      delete cleanedInput.description;
    }

    return SimpleOrderService.createSimpleOrder(cleanedInput);
  };

  const getSimpleOrders = (variables) => {
    const queryVariables = buildQueryVariables(variables);
    return SimpleOrderService.getSimpleOrders(queryVariables);
  };

  const getSimpleOrderById = (id) => {
    return SimpleOrderService.getSimpleOrderById(id);
  };

  const getSimpleOrdersForAdmin = (variables) => {
    const queryVariables = buildQueryVariables(variables);
    return SimpleOrderService.getSimpleOrdersForAdmin(queryVariables);
  };

  const getSimpleOrderByIdForAdmin = (id) => {
    return SimpleOrderService.getSimpleOrderByIdForAdmin(id);
  };

  const updateSimpleOrderStatus = (id, data) => {
    return SimpleOrderService.updateSimpleOrderStatus(id, data);
  };

  const updateSimpleOrderNotes = (id, data) => {
    return SimpleOrderService.updateSimpleOrderNotes(id, data);
  };

  return {
    createSimpleOrder,
    getSimpleOrders,
    getSimpleOrderById,
    getSimpleOrdersForAdmin,
    getSimpleOrderByIdForAdmin,
    updateSimpleOrderStatus,
    updateSimpleOrderNotes,
  };
}
